import Model from './Model'

export default class PostReport extends Model {
  resource() {
    return 'report'
  }
}
